// @ts-nocheck
import React from "react";
import ReactDOM from "react-dom/client";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import enGB from "date-fns/locale/en-GB";
import "./index.css";
import "material-icons/iconfont/material-icons.css";
import "common/HttpInterceptor";
import store from "common/Store";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      <BrowserRouter>
        <ReduxProvider store={store}>
          <App />
        </ReduxProvider>
      </BrowserRouter>
    </LocalizationProvider>
  </React.StrictMode>
);
